var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{staticStyle:{"overflow":"hidden"},attrs:{"id":"main_content"}},[(_vm.geted_login_status)?_c('LeftSide'):_vm._e(),(_vm.geted_login_status)?_c('RightSide'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }